import { API_BASE } from './api';

async function parseResponse(response) {
  const contentType = response.headers.get('content-type') || '';

  if (contentType.includes('application/json')) {
    const payload = await response.json();
    if (!response.ok) {
      throw new Error(payload.error || 'Request failed.');
    }

    return payload;
  }

  const text = await response.text();
  if (!response.ok) {
    throw new Error(text || 'Request failed.');
  }

  return text;
}

export async function fetchReports(page = 1, per = 50) {
  const params = new URLSearchParams({
    page: String(page),
    per: String(per)
  });
  const response = await fetch(`${API_BASE}/reports?${params.toString()}`);
  return parseResponse(response);
}

export function getReportDownloadUrl(reportId) {
  return `${API_BASE}/reports/${encodeURIComponent(reportId)}/download`;
}

export async function uploadReport(formData) {
  const response = await fetch(`${API_BASE}/upload`, {
    body: formData,
    method: 'POST'
  });

  return parseResponse(response);
}
